export default [
  {
    path: "/app/ai",
    component: () => import("../views"),
    meta: {
      title: "Educasis - IA",
      requiresAuth: true,
    },
    children: [
      {
        path: "content-generator",
        name: "ai.content-generator",
        component: () => import("../content-generator/views/index.vue"),
        meta: {
          permission: "view_ai_content_generation",
        },
      },
      {
        path: "content-generator/create",
        name: "ai.content-generator.create",
        component: () => import("../content-generator/views/Create.vue"),
        meta: {
          permission: "view_ai_content_generation",
        },
      },
      {
        path: "content-generator/:id",
        name: "ai.content-generator.show",
        component: () => import("../content-generator/views/Show.vue"),
        meta: {
          permission: "view_ai_content_generation",
        },
      },
    ],
  },
];
